import { SUPPORTED_LOCALES } from '@klarna-web-sdk/messaging/src/config';
export default function isValidLocale(locale, supportedLocales = SUPPORTED_LOCALES) {
    if (!locale) {
        return false;
    }
    return supportedLocales.includes(locale.toLowerCase());
}
